var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97345C0 7.42157 0 7.14563 0.0740273 6.89151C0.139601 6.66641 0.247366 6.4547 0.392027 6.26677C0.555337 6.05461 0.782021 5.8852 1.23539 5.54638L8.0177 0.477696C8.36902 0.215138 8.54468 0.0838583 8.73865 0.0333949C8.9098 -0.0111316 9.0902 -0.0111316 9.26135 0.0333949C9.45532 0.0838583 9.63098 0.215138 9.98231 0.477697L16.7646 5.54638C17.218 5.8852 17.4447 6.05461 17.608 6.26677C17.7526 6.4547 17.8604 6.66641 17.926 6.89151C18 7.14563 18 7.42157 18 7.97345V14.9252C18 16.0015 18 16.5396 17.782 16.9507C17.5903 17.3123 17.2843 17.6063 16.908 17.7905C16.4802 18 15.9201 18 14.8 18H3.2C2.0799 18 1.51984 18 1.09202 17.7905C0.715695 17.6063 0.409734 17.3123 0.217987 16.9507C0 16.5396 0 16.0015 0 14.9252V7.97345Z",
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_192381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2895 7.34395L9.26314 9.49999M9.26314 9.49999L5.23683 7.34395M9.26314 9.49999L9.26316 13.8374M10.2105 13.5584L9.63123 13.8686C9.49689 13.9406 9.42972 13.9765 9.35858 13.9906C9.29563 14.0031 9.23069 14.0031 9.16773 13.9906C9.0966 13.9765 9.02943 13.9406 8.89509 13.8686L5.38983 11.9916C5.24795 11.9156 5.17701 11.8776 5.12535 11.8236C5.07965 11.7758 5.04507 11.7192 5.02391 11.6575C5 11.5877 5 11.5095 5 11.353V7.64698C5 7.49053 5 7.41231 5.02391 7.34255C5.04507 7.28083 5.07965 7.22418 5.12535 7.17638C5.17701 7.12235 5.24795 7.08436 5.38983 7.00839L8.89509 5.13137C9.02943 5.05943 9.0966 5.02346 9.16773 5.00936C9.23069 4.99688 9.29563 4.99688 9.35858 5.00936C9.42972 5.02346 9.49689 5.05943 9.63123 5.13137L13.1365 7.00839C13.2784 7.08436 13.3493 7.12235 13.401 7.17638C13.4467 7.22418 13.4812 7.28083 13.5024 7.34255C13.5263 7.41231 13.5263 7.49053 13.5263 7.64697L13.5263 9.72829M7.13158 6.0757L11.3947 8.35857M11.1579 12.2394L12.1053 13.1526L14 11.3263",
    stroke: "url(#paint0_linear_415_192381)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_192381",
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_192381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_192381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_192381",
    x1: 5,
    y1: 5,
    x2: 14.1537,
    y2: 5.15914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneBox);
export default __webpack_public_path__ + "static/media/OneBox.326e2ef5acb92890c9d2c5989f4ff797.svg";
export { ForwardRef as ReactComponent };